import { render, staticRenderFns } from "./PlaceSelect.vue?vue&type=template&id=33a8134c&"
import script from "./PlaceSelect.vue?vue&type=script&lang=js&"
export * from "./PlaceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports